import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SaasMetrics } from '../models/saas.models';

/**
 * Servicio de Métricas SaaS
 * Dashboard de KPIs y métricas clave del negocio
 */
@Injectable({
  providedIn: 'root'
})
export class MetricsService {
  
  private readonly API_URL = `${environment.adminApiUrl}saas/metrics`;

  constructor(private http: HttpClient) { }

  /**
   * Obtener todas las métricas principales
   */
  getMetrics(period?: 'month' | 'quarter' | 'year'): Observable<SaasMetrics> {
    let params = new HttpParams();
    if (period) params = params.set('period', period);
    
    return this.http.get<SaasMetrics>(this.API_URL, { params });
  }

  /**
   * Obtener tasa de churn (endpoint real: /metrics/churn-rate)
   */
  getChurnRate(months?: number): Observable<any> {
    let params = new HttpParams();
    if (months) params = params.set('months', months.toString());
    
    return this.http.get<any>(`${this.API_URL}/churn-rate`, { params });
  }

  /**
   * Obtener datos para gráfico de MRR en el tiempo
   */
  getMRRHistory(months: number = 12): Observable<any> {
    let params = new HttpParams();
    params = params.set('months', months.toString());
    return this.http.get<any>(`${this.API_URL}/mrr-history`, { params });
  }

  /**
   * Obtener distribución de clientes por plan
   */
  getPlanDistribution(): Observable<any> {
    return this.http.get<any>(`${this.API_URL}/plan-distribution`);
  }

  /**
   * Obtener análisis de cohorts
   */
  getCohortAnalysis(months?: number): Observable<any> {
    let params = new HttpParams();
    if (months) params = params.set('months', months.toString());
    return this.http.get<any>(`${this.API_URL}/cohorts`, { params });
  }
}
